import { createActions } from 'redux-actions';

const action = createActions({
  ONBOARDING: {
    SELECT_PLAN: (plan) => ({ plan })
  }
})

const configuration = {
  name: 'selectPlan',
  action: action,
  sagas: undefined,
  reducers: {
    reducer: (state, action) => ({
      ...state,
      onboarding: {
        ...state.onboarding,
        selectedPlan: action.payload.plan
      }
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/global/configurations/selectPlan.js